import React from "react"

// NEW ICONS START AT 728

export const plus = ({ style, color }) => (
  <svg
    style={style}
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-42.000000, -68.000000)"
        stroke={color}
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="plus" transform="translate(0.000000, 8.000000)">
            <path d="M10,0 L10,20" id="Line" />
            <path d="M0,10 L20,10" id="Line" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const close = ({ style, color }) => (
  <svg
    style={style}
    width="17px"
    height="17px"
    viewBox="0 0 17 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-92.000000, -71.000000)"
        stroke={color}
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="close" transform="translate(49.000000, 10.000000)">
            <path
              d="M8.14213562,-1.85786438 L8.14213562,18.1421356"
              id="Line"
              transform="translate(8.142136, 8.142136) rotate(-45.000000) translate(-8.142136, -8.142136) "
            />
            <path
              d="M-1.85786438,8.14213562 L18.1421356,8.14213562"
              id="Line"
              transform="translate(8.142136, 8.142136) rotate(-45.000000) translate(-8.142136, -8.142136) "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const back = ({ style, color }) => (
  <svg
    style={style}
    width="19px"
    height="17px"
    viewBox="0 0 19 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-136.000000, -70.000000)"
        stroke={color}
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="back" transform="translate(93.000000, 10.000000)">
            <path
              d="M5,6 L5,16"
              id="Line"
              transform="translate(5.000000, 11.000000) rotate(-225.000000) translate(-5.000000, -11.000000) "
            />
            <path
              d="M0,4 L10,4"
              id="Line"
              transform="translate(5.000000, 4.000000) rotate(-225.000000) translate(-5.000000, -4.000000) "
            />
            <path d="M3,8 L18,8" id="Line-7" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const forward = ({ style, color }) => (
  <svg
    style={style}
    width="19px"
    height="17px"
    viewBox="0 0 19 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-178.000000, -70.000000)"
        stroke={color}>
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="forward" transform="translate(134.000000, 10.000000)">
            <g
              id="Group"
              transform="translate(10.500000, 8.000000) scale(-1, 1) translate(-10.500000, -8.000000) translate(2.000000, 0.000000)">
              <path
                d="M4.24264069,6.24264069 L4.24264069,16.2426407"
                id="Line-Copy"
                strokeWidth="2"
                transform="translate(4.242641, 11.242641) rotate(-225.000000) translate(-4.242641, -11.242641) "
              />
              <path
                d="M-0.757359313,4.24264069 L9.24264069,4.24264069"
                id="Line-Copy-2"
                strokeWidth="2"
                transform="translate(4.242641, 4.242641) rotate(-225.000000) translate(-4.242641, -4.242641) "
              />
              <path d="M2,8 L17,8" id="Line-7-Copy" strokeWidth="2" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const checkmark = ({ style, color }) => (
  <svg
    style={style}
    width="24px"
    height="17px"
    viewBox="0 0 24 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-214.000000, -68.000000)"
        stroke={color}
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="check" transform="translate(172.000000, 7.000000)">
            <path
              d="M14.8994949,-1.30151519 L14.8994949,18.6984848"
              id="Line"
              transform="translate(14.899495, 8.698485) scale(1, -1) rotate(-45.000000) translate(-14.899495, -8.698485) "
            />
            <path
              d="M-0.707106781,12.2340187 L9.29289322,12.2340187"
              id="Line"
              transform="translate(4.292893, 12.234019) scale(1, -1) rotate(-45.000000) translate(-4.292893, -12.234019) "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const complete = ({ style, color }) => (
  <svg
    style={style}
    width="31px"
    height="28px"
    viewBox="0 0 31 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g
        id="icon-system"
        transform="translate(-253.000000, -64.000000)"
        stroke={color}
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="circle-check" transform="translate(207.000000, 0.000000)">
            <path
              d="M25.8994949,3.69848481 L25.8994949,23.6984848"
              id="Line"
              transform="translate(25.899495, 13.698485) scale(1, -1) rotate(-45.000000) translate(-25.899495, -13.698485) "
            />
            <path
              d="M10.2928932,17.2340187 L20.2928932,17.2340187"
              id="Line"
              transform="translate(15.292893, 17.234019) scale(1, -1) rotate(-45.000000) translate(-15.292893, -17.234019) "
            />
            <path
              d="M17.224592,29.724592 C24.1281514,29.724592 29.724592,24.1281514 29.724592,17.224592 C29.724592,16.6482844 29.6855911,16.081086 29.6100847,15.525492 C29.3986855,13.969967 28.9011338,12.5054051 28.1721929,11.1865698 C27.4434853,9.86815654 26.4835367,8.69537661 25.3470579,7.72294098 C23.1623635,5.85359268 20.3253239,4.724592 17.224592,4.724592 C10.3210326,4.724592 4.724592,10.3210326 4.724592,17.224592 C4.724592,18.3522072 4.87390157,19.4449493 5.15382886,20.4841265 C5.4977388,21.7608271 6.03880069,22.9566778 6.74235276,24.0370168"
              id="Oval-7-Copy-3"
              transform="translate(17.224592, 17.224592) rotate(-148.000000) translate(-17.224592, -17.224592) "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const home = ({ style, color }) => (
  <svg
    style={style}
    width="26px"
    height="24px"
    viewBox="0 0 26 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-342.000000, -65.000000)"
        stroke={color}
        strokeWidth="2">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="home" transform="translate(300.000000, 5.000000)">
            <path
              d="M13.0556708,0.426960853 C12.4709916,-0.142320284 11.5295498,-0.142320284 10.9448705,0.426960853 L0.562483082,10.5307691 C0.202472255,10.8806453 0,11.3577977 0,11.855719 L0,20.0865976 C0,21.1431493 0.871063791,22 1.94514121,22 L6.76657945,22 C7.84119823,22 8.71172065,21.1431493 8.71172065,20.0865976 L8.71172065,14.4161528 C8.71172065,13.3611987 9.58116034,12.5059456 10.6536136,12.5059456 L13.0047821,12.5059456 C14.0772354,12.5059456 14.9466751,13.3611987 14.9466751,14.4161528 L14.9466751,20.0865976 C14.9466751,21.1431493 15.8177389,22 16.8918163,22 L22.0548588,22 C23.1294776,22 24,21.1431493 24,20.0865976 L24,11.855719 C24,11.3577977 23.7975277,10.8806453 23.4380583,10.5307691 L13.0556708,0.426960853 Z"
              id="Fill-1-Copy-2"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)
export const trash = ({ style, color }) => (
  <svg
    style={style}
    width="19px"
    height="26px"
    viewBox="0 0 19 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon-system" transform="translate(-508.000000, -63.000000)">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="trash" transform="translate(465.000000, 1.000000)">
            <path
              d="M3.04166203,7 C2.97125039,7 2.90088787,7.00371835 2.8308684,7.01113951 C1.73245109,7.12755762 0.936383436,8.11237631 1.05280154,9.21079363 L2.54779217,23.3161904 C2.70951877,24.8420983 3.99662851,26 5.5310829,26 L13.4691355,26 C15.0035899,26 16.2906997,24.8420983 16.4524263,23.3161904 L17.9474169,9.21079363 C17.9548381,9.14077416 17.9585564,9.07041164 17.9585564,9 C17.9585564,7.8954305 17.0631259,7 15.9585564,7 L3.04166203,7 Z"
              id="Rectangle-17"
              stroke={color}
              strokeWidth="2"
            />
            <rect
              id="Rectangle-18"
              fill="#222232"
              fillRule="evenodd"
              x="0"
              y="3"
              width="19"
              height="2"
              rx="1"
            />
            <rect
              id="Rectangle-18-Copy-2"
              fill="#222232"
              fillRule="evenodd"
              x="6"
              y="1"
              width="7"
              height="3"
              rx="1"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const world = ({ style, color }) => (
  <svg
    style={style}
    width="27px"
    height="27px"
    viewBox="0 0 27 27"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-543.000000, -63.000000)"
        stroke={color}>
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="world" transform="translate(501.000000, 3.000000)">
            <g id="Group-5-Copy-3">
              <circle
                id="Oval-8"
                strokeWidth="2"
                cx="12.5"
                cy="12.5"
                r="12.5"
              />
              <g
                id="Group-2"
                transform="translate(4.000000, 0.000000)"
                strokeWidth="2">
                <path
                  d="M-8.8817842e-16,4.3085351 C-8.8817842e-16,4.3085351 1.09505837,5.39596163 2.18784073,5.04841799 C3.28062309,4.70087435 5.1630267,3.08814214 6.14479656,4.71268833 C7.12656642,6.33723451 5.93796474,6.06676376 4.33912241,8.80130497 C3.75763775,9.79583316 4.93706887,11.9788381 4.65133584,13.5284422 C4.57149886,13.9614188 3.80930319,13.8981362 3.43137175,13.7242715 C2.5917765,13.3380216 2.11561261,11.6816105 1.23942522,11.9588166 C-0.310268288,12.4491051 0.417692065,17.4730766 1.79668733,17.6327666 C2.6432203,17.7307965 3.53300034,17.0057324 4.33912241,16.7115113 C8.58912258,15.1603324 5.61005547,20.2653782 5.66071351,21.0672413 C5.7154427,21.9335464 7.27402346,23.0278419 6.74144604,24.5042918"
                  id="Path-5"
                />
                <path
                  d="M13.3024488,0.958572774 C15.2650339,4.0159406 14.0560523,7.56272253 11.2221855,8.05115572 C9.86172371,8.28563909 9.5830221,12.1699584 10.6598524,15.1315987 C11.4952921,17.4293346 15.3677889,11.5887444 15.9460576,14.5090848 C16.6593996,18.1115651 9.96998335,20.1015899 15.1509636,23"
                  id="Path-6"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const edit = ({ style, color }) => (
  <svg
    style={style}
    width="13px"
    height="13px"
    viewBox="0 0 13 13"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      fillOpacity="1">
      <g id="edit" fill={color}>
        <path
          d="M11.6221841,3.89963754 L9.10064653,1.37810001 L10.1963806,0.281884093 C10.5722261,-0.0939613642 11.1817703,-0.0939613642 11.5576157,0.281884093 L12.7179181,1.44218648 C13.0942454,1.81851379 13.0942454,2.42757617 12.7179181,2.80390348 L11.6221841,3.89963754 Z M1.32536774,9.42119278 L3.57851307,11.6743381 L0.346242138,12.9902791 C0.141936402,13.0447285 -0.0445407667,12.8582513 0.00942678609,12.6539456 L1.32536774,9.42119278 Z M4.87623997,10.6455816 L2.35470244,8.1240441 L7.93745303,2.54129351 L10.4589906,5.06283104 L4.87623997,10.6455816 Z"
          id="Combined-Shape"
        />
      </g>
    </g>
  </svg>
)

export const logout = ({ style }) => (
  <svg
    style={style}
    width="32px"
    height="34px"
    viewBox="0 0 32 34"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-753.000000, -61.000000)"
        stroke="#222232">
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g id="Logout" transform="translate(710.000000, 0.000000)">
            <g id="Group-18">
              <g
                id="forward"
                transform="translate(22.000000, 14.000000)"
                strokeLinecap="round">
                <g
                  id="Group"
                  transform="translate(4.725000, 3.500000) scale(-1, 1) translate(-4.725000, -3.500000) translate(0.900000, 0.000000)">
                  <path
                    d="M1.90918831,2.7311553 L1.90918831,7.1061553"
                    id="Line-Copy"
                    strokeWidth="2"
                    transform="translate(1.909188, 4.918655) rotate(-225.000000) translate(-1.909188, -4.918655) "
                  />
                  <path
                    d="M-0.340811691,1.8561553 L4.15918831,1.8561553"
                    id="Line-Copy-2"
                    strokeWidth="2"
                    transform="translate(1.909188, 1.856155) rotate(-225.000000) translate(-1.909188, -1.856155) "
                  />
                  <path
                    d="M0.9,3.5 L7.65,3.5"
                    id="Line-7-Copy"
                    strokeWidth="2"
                  />
                </g>
              </g>
              <path
                d="M2.70331909,3.60568956 C1.72427918,3.75254554 1,4.59356942 1,5.58356226 L1,28.4164377 C1,29.4064306 1.72427918,30.2474545 2.70331909,30.3943104 L16.7033191,32.4943104 C16.8015262,32.5090415 16.9006942,32.5164377 17,32.5164377 C18.1045695,32.5164377 19,31.6210072 19,30.5164377 L19,3.48356226 C19,3.38425643 18.9926038,3.2850885 18.9778727,3.18688136 C18.8140204,2.09453242 17.795668,1.34183722 16.7033191,1.50568956 L2.70331909,3.60568956 Z"
                id="Rectangle-9"
                strokeWidth="2"
              />
              <path
                d="M23,29 L24,29 C25.6568542,29 27,27.6568542 27,26 L27,25 M27,10 L27,9 C27,7.34314575 25.6568542,6 24,6 L23,6"
                id="Path-4"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const settings = ({ style }) => (
  <svg
    style={style}
    width="33px"
    height="33px"
    viewBox="0 0 33 33"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-800.000000, -62.000000)"
        stroke="#222232"
        strokeWidth="2">
        <g id="settings" transform="translate(796.000000, 58.000000)">
          <path
            d="M12.9634518,10.1609937 C13.6553535,9.68172899 14.3975453,9.26696095 15.1808034,8.92568202 L15.641733,7.00996465 L15.641733,7.00996465 C15.8579643,6.11126333 16.6618923,5.47782132 17.5862407,5.47782132 L17.5862407,5.47782132 L23.3510132,5.47782132 L23.3510132,5.47782132 C24.2753616,5.47782132 25.0792896,6.11126333 25.2955209,7.00996465 L25.7564505,8.92568202 C26.5397086,9.26696095 27.2819004,9.68172899 27.9738021,10.1609937 L29.993983,9.56368022 C30.8803968,9.30159135 31.8309376,9.68109238 32.2931118,10.4816016 L32.2931118,10.4816016 L35.1754981,15.474041 L35.1754981,15.474041 C35.6376723,16.2745503 35.4910594,17.2874933 34.8208769,17.9241058 L33.3845326,19.2885022 C33.42199,19.6800336 33.44114,20.0767472 33.44114,20.4778213 C33.44114,20.8788955 33.42199,21.2756091 33.3845326,21.6671405 L34.8208769,23.0315369 L34.8208769,23.0315369 C35.4910594,23.6681493 35.6376723,24.6810924 35.1754981,25.4816016 L32.2931118,30.474041 C31.8309376,31.2745503 30.8803968,31.6540513 29.993983,31.3919624 L27.9738021,30.7946489 C27.2819004,31.2739137 26.5397086,31.6886817 25.7564505,32.0299606 L25.2955209,33.945678 C25.0792896,34.8443793 24.2753616,35.4778213 23.3510132,35.4778213 L17.5862407,35.4778213 C16.6618923,35.4778213 15.8579643,34.8443793 15.641733,33.945678 L15.1808034,32.0299606 C14.3975453,31.6886817 13.6553535,31.2739137 12.9634518,30.7946489 L10.943271,31.3919624 C10.0568571,31.6540513 9.10631629,31.2745503 8.64414207,30.474041 L5.76175583,25.4816016 L5.76175583,25.4816016 C5.2995816,24.6810924 5.4461945,23.6681493 6.11637703,23.0315369 L6.11637703,23.0315369 L7.55272128,21.6671405 C7.51526395,21.2756091 7.49611389,20.8788955 7.49611389,20.4778213 C7.49611389,20.0767472 7.51526395,19.6800336 7.55272128,19.2885022 L6.11637703,17.9241058 C5.4461945,17.2874933 5.2995816,16.2745503 5.76175583,15.474041 L8.64414207,10.4816016 L8.64414207,10.4816016 C9.10631629,9.68109238 10.0568571,9.30159135 10.943271,9.56368022 L10.943271,9.56368022 L12.9634518,10.1609937 Z M20.468627,28.0366449 C24.750678,28.0366449 28.2219662,24.6524443 28.2219662,20.4778213 C28.2219662,16.3031984 24.750678,12.9189978 20.468627,12.9189978 C16.186576,12.9189978 12.7152878,16.3031984 12.7152878,20.4778213 C12.7152878,24.6524443 16.186576,28.0366449 20.468627,28.0366449 Z"
            id="Combined-Shape"
            transform="translate(20.468627, 20.477821) rotate(-330.000000) translate(-20.468627, -20.477821) "
          />
        </g>
      </g>
    </g>
  </svg>
)

export const documentation = ({ style, color }) => (
  <svg
    style={style}
    width="19px"
    height="16px"
    viewBox="0 0 19 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="03-–-Seller-Dashboard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      fillOpacity="0.2">
      <g
        id="Dashboard-Product-–-Price-Product"
        transform="translate(-100.000000, -680.000000)"
        fill={color}>
        <path
          d="M109.111357,695.942148 L108.520189,695.646014 C106.287073,694.529181 103.620764,694.529181 101.387648,695.646014 C101.088761,695.796283 100.739235,695.77977 100.45466,695.604181 C100.170085,695.428592 100,695.123651 100,694.788986 L100,681.560373 C100,681.058927 100.339619,680.623532 100.825653,680.502436 C103.272338,679.890352 105.880301,679.83641 108.367168,680.346663 C108.62312,680.398404 108.806966,680.624083 108.806966,680.885539 L108.806966,692.697332 C108.806966,693.001172 109.053561,693.247767 109.357401,693.247767 C109.661241,693.247767 109.907836,693.001172 109.907836,692.697332 L109.907836,680.885539 C109.907836,680.624083 110.091682,680.398404 110.347634,680.346663 C112.835052,679.83641 115.442464,679.890352 117.888599,680.502436 C118.375184,680.623532 118.714802,681.058927 118.714802,681.560373 L118.714802,694.788986 C118.714802,695.123651 118.544718,695.428592 118.260143,695.604181 C117.974467,695.78032 117.625491,695.795732 117.327155,695.646014 C115.094038,694.529181 112.42773,694.529181 110.194613,695.646014 L109.603446,695.942148 C109.526385,695.980679 109.441618,695.999944 109.357401,695.999944 C109.273185,695.999944 109.188417,695.980679 109.111357,695.942148 Z"
          id="Page-1"
        />
      </g>
    </g>
  </svg>
)

export const search = ({ style, color }) => (
  <svg
    style={style}
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-1070.000000, -66.000000)"
        stroke={color}>
        <g id="Icon-Outlines" transform="translate(43.000000, 61.000000)">
          <g
            id="Group-47"
            transform="translate(1039.000000, 17.500000) rotate(-45.000000) translate(-1039.000000, -17.500000) translate(1030.000000, 6.000000)">
            <g id="search">
              <g id="Group-48">
                <circle
                  id="Combined-Shape"
                  strokeWidth="2"
                  cx="9"
                  cy="9"
                  r="9"
                />
                <path
                  d="M9,18 L9,23"
                  id="Line-21"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const profile = ({ style, color }) => (
  <svg
    style={style}
    width="20px"
    height="26px"
    viewBox="0 0 20 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="icon-system"
        transform="translate(-1379.000000, -62.000000)"
        stroke={color}
        strokeWidth="2">
        <g id="Group-19-Copy" transform="translate(1380.000000, 63.000000)">
          <path
            d="M14,5 C14,7.76142857 11.7614286,10 9,10 C6.23857143,10 4,7.76142857 4,5 C4,2.23857143 6.23857143,0 9,0 C11.7614286,0 14,2.23857143 14,5"
            id="Fill-1"
          />
          <path
            d="M12.4642078,12.0579434 C11.4503896,12.7276603 10.2657662,13.1126353 9,13.1126353 C7.73418182,13.1126353 6.54961039,12.7276603 5.53579221,12.0579434 C5.4318961,11.9892781 5.30467532,11.9820199 5.19324675,12.0341525 C2.14181818,13.4612613 0,16.8095004 0,20.7125343 L0,22.151049 C0,23.1722146 0.746493506,24 1.66732468,24 L16.3326753,24 C17.2535065,24 18,23.1722146 18,22.151049 L18,20.7125343 C18,16.8095004 15.8581299,13.4612613 12.8067013,12.0341525 C12.6952727,11.9820199 12.5681039,11.9892781 12.4642078,12.0579434 Z"
            id="Fill-3"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const code = ({ style, color }) => (
  <svg
    style={style}
    width="17px"
    height="17px"
    viewBox="0 0 17 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g id="embed" fill={color}>
        <g id="Group-5">
          <path
            d="M17,8.73958125 L17,14.3344 C17,15.8042667 15.8042667,17 14.3344,17 L8.73958125,17 L3.1864375,17 C1.4269375,17 0,15.5730625 0,13.8135625 L0,3.1864375 C0,1.4269375 1.4269375,0 3.1864375,0 L13.8135625,0 C15.5735937,0 17,1.4269375 17,3.1864375 L17,8.73958125 Z"
            id="Combined-Shape"
            fillOpacity="0.2"
          />
          <path
            d="M6.027,6.203 L2.826,8.458 L6.027,10.702 L5.169,11.692 L1.495,9.041 L1.495,7.864 L5.169,5.213 L6.027,6.203 Z M9.19866665,3.805 L10.5296667,3.805 L7.69166665,12.891 L6.37166665,12.891 L9.19866665,3.805 Z M11.6003333,5.213 L15.2743333,7.864 L15.2743333,9.041 L11.6003333,11.692 L10.7423333,10.702 L13.9323333,8.458 L10.7423333,6.203 L11.6003333,5.213 Z"
            id="&lt;/&gt;"
            fillOpacity="0.6"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const location = ({ style, color }) => (
  <svg
    width="12px"
    height="15px"
    viewBox="0 0 12 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="03-–-Seller-Dashboard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g
        id="Dashboard-Product-–-Price-Product"
        transform="translate(-107.000000, -395.000000)">
        <g id="location" transform="translate(107.000000, 395.000000)">
          <g id="Group-52">
            <path
              d="M6,14.8877005 C7.26720418,14.8877005 12,9.61061272 12,5.8487395 C12,2.08686628 9.3137085,0 6,0 C2.6862915,0 1.85668673e-16,2.08686628 0,5.8487395 C0,9.61061272 4.73279582,14.8877005 6,14.8877005 Z"
              id="Oval-8-Copy-3"
              fillOpacity="0.2"
              fill={color}
            />
            <ellipse
              id="Oval-8-Copy-6"
              fill="#FFFFFF"
              cx="6"
              cy="5.13157895"
              rx="3.6"
              ry="3.55263158"
            />
            <ellipse
              id="Oval-8-Copy-6"
              fillOpacity="0.6"
              fill={color}
              cx="6"
              cy="5.13157895"
              rx="2.8"
              ry="2.76315789"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const delivery = ({ style, color }) => (
  <svg
    style={style}
    width="23px"
    height="14px"
    viewBox="0 0 23 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="03-–-Seller-Dashboard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g
        id="Dashboard-Product-–-Price-Product"
        transform="translate(-104.000000, -419.000000)"
        fill={color}>
        <g id="delivery" transform="translate(104.000000, 419.000000)">
          <path
            d="M14,11 L1.99866667,11 C0.894666667,11 0,10.1316471 0,9.06011765 L0,1.93988235 C0,0.868352941 0.894666667,0 1.99866667,0 L13.0013333,0 C14.1053333,0 15,0.868352941 15,1.93988235 L15,10 L15,10 C15,10.5522847 14.5522847,11 14,11 Z"
            id="Fill-1"
            fillOpacity="0.2"
          />
          <path
            d="M15.069041,11.4771284 C15.1360741,11.2289747 15.2496679,10.9999404 15.3998712,10.7999765 C15.1570551,10.6175293 15,10.3271057 15,10 L15,4 L15,4 C15,3.44771525 15.4477153,3 16,3 L17.381966,3 L17.381966,3 C17.7607381,3 18.1070012,3.21400238 18.2763932,3.5527864 L20,7 L22,7 C22.5522847,7 23,7.44771525 23,8 L23,10 C23,10.3661455 22.803219,10.6863303 22.5096456,10.8605659 L22.5096456,10.9771284 C22.5096456,11.8055556 21.8380727,12.4771284 21.0096456,12.4771284 L18.9427334,12.4771284 C18.728768,13.3513232 17.9401373,14 17,14 C16.0598627,14 15.271232,13.3513232 15.0572666,12.4771284 L6.94273339,12.4771284 C6.728768,13.3513232 5.94013729,14 5,14 C4.05986271,14 3.271232,13.3513232 3.05726661,12.4771284 L1.01982046,12.4771284 C0.743678089,12.4771284 0.519820464,12.2532708 0.519820464,11.9771284 C0.519820464,11.7009861 0.743678089,11.4771284 1.01982046,11.4771284 L3.06904099,11.4771284 C3.29891542,10.6261436 4.07633587,10 5,10 C5.92366413,10 6.70108458,10.6261436 6.93095901,11.4771284 L15.069041,11.4771284 Z M18.930959,11.4771284 L21.0096456,11.4771284 C21.2781226,11.4771284 21.4971773,11.2655263 21.5091318,11 L18.7324356,11 C18.8180991,11.1480866 18.8853204,11.3081762 18.930959,11.4771284 Z"
            id="Combined-Shape"
            fillOpacity="0.4"
          />
          <circle
            id="Oval-2-Copy-2"
            fillOpacity="0.6"
            cx="8.5"
            cy="5.5"
            r="3.5"
          />
        </g>
      </g>
    </g>
  </svg>
)

// NEW ICONS

export const chevron = ({ style, color }) => (
  <svg
    style={style}
    width="7px"
    height="12px"
    viewBox="0 0 7 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g id="chevron" stroke={color} strokeWidth="2">
        <g
          id="Group-8"
          transform="translate(3.500000, 6.000000) rotate(-90.000000) translate(-3.500000, -6.000000) translate(-2.500000, 2.500000)">
          <path
            d="M3.5,0 L3.5,7"
            id="Line-Copy"
            transform="translate(3.500000, 3.500000) rotate(-225.000000) translate(-3.500000, -3.500000) "
          />
          <path
            d="M5,3.5 L12,3.5"
            id="Line-Copy-2"
            transform="translate(8.500000, 3.500000) rotate(-225.000000) translate(-8.500000, -3.500000) "
          />
        </g>
      </g>
    </g>
  </svg>
)

export const carrot = ({ style, color }) => (
  <svg
    width="12px"
    height="7px"
    viewBox="0 0 12 7"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round">
      <g id="carrot" strokeWidth="2" stroke={color}>
        <g id="Group-8">
          <path
            d="M3.5,0 L3.5,7"
            id="Line-Copy"
            transform="translate(3.500000, 3.500000) rotate(-225.000000) translate(-3.500000, -3.500000) "
          />
          <path
            d="M5,3.5 L12,3.5"
            id="Line-Copy-2"
            transform="translate(8.500000, 3.500000) rotate(-225.000000) translate(-8.500000, -3.500000) "
          />
        </g>
      </g>
    </g>
  </svg>
)

export const move = ({ style, color }) => (
  <svg
    style={style}
    width="12px"
    height="12px"
    viewBox="0 0 12 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      fillOpacity="1">
      <g id="move" transform="translate(-1.000000, -1.000000)" fill={color}>
        <g id="Group-7">
          <g id="Group-6" transform="translate(0.000000, 5.000000)">
            <path
              d="M1.18469812,1.58763557 L3.30056916,0.136752579 L3.30056916,0.136752579 C3.52831174,-0.0194137641 3.83953142,0.0386102434 3.99569776,0.266352827 C4.05278212,0.349600847 4.08333333,0.448177139 4.08333333,0.549117005 L4.08333333,3.450883 L4.08333333,3.450883 C4.08333333,3.72702537 3.85947571,3.950883 3.58333333,3.950883 C3.48239347,3.950883 3.38381718,3.92033178 3.30056916,3.86324742 L1.18469812,2.41236443 L1.18469812,2.41236443 C0.956955537,2.25619808 0.89893153,1.94497841 1.05509787,1.71723582 C1.08994348,1.66641931 1.13388161,1.62248118 1.18469812,1.58763557 Z"
              id="Triangle"
            />
            <path
              d="M10.1339497,1.58763557 L12.2498207,0.136752579 L12.2498207,0.136752579 C12.4775633,-0.0194137641 12.788783,0.0386102434 12.9449493,0.266352827 C13.0020337,0.349600847 13.0325849,0.448177139 13.0325849,0.549117005 L13.0325849,3.450883 L13.0325849,3.450883 C13.0325849,3.72702537 12.8087273,3.950883 12.5325849,3.950883 C12.431645,3.950883 12.3330687,3.92033178 12.2498207,3.86324742 L10.1339497,2.41236443 L10.1339497,2.41236443 C9.9062071,2.25619808 9.8481831,1.94497841 10.0043494,1.71723582 C10.039195,1.66641931 10.0831332,1.62248118 10.1339497,1.58763557 Z"
              id="Triangle"
              transform="translate(11.474626, 1.999976) scale(-1, 1) translate(-11.474626, -1.999976) "
            />
          </g>
          <g
            id="Group-6"
            transform="translate(7.000000, 7.000000) rotate(-90.000000) translate(-7.000000, -7.000000) translate(0.000000, 5.000000)">
            <path
              d="M1.18469812,1.58763557 L3.30056916,0.136752579 L3.30056916,0.136752579 C3.52831174,-0.0194137641 3.83953142,0.0386102434 3.99569776,0.266352827 C4.05278212,0.349600847 4.08333333,0.448177139 4.08333333,0.549117005 L4.08333333,3.450883 L4.08333333,3.450883 C4.08333333,3.72702537 3.85947571,3.950883 3.58333333,3.950883 C3.48239347,3.950883 3.38381718,3.92033178 3.30056916,3.86324742 L1.18469812,2.41236443 L1.18469812,2.41236443 C0.956955537,2.25619808 0.89893153,1.94497841 1.05509787,1.71723582 C1.08994348,1.66641931 1.13388161,1.62248118 1.18469812,1.58763557 Z"
              id="Triangle"
            />
            <path
              d="M10.1339497,1.58763557 L12.2498207,0.136752579 L12.2498207,0.136752579 C12.4775633,-0.0194137641 12.788783,0.0386102434 12.9449493,0.266352827 C13.0020337,0.349600847 13.0325849,0.448177139 13.0325849,0.549117005 L13.0325849,3.450883 L13.0325849,3.450883 C13.0325849,3.72702537 12.8087273,3.950883 12.5325849,3.950883 C12.431645,3.950883 12.3330687,3.92033178 12.2498207,3.86324742 L10.1339497,2.41236443 L10.1339497,2.41236443 C9.9062071,2.25619808 9.8481831,1.94497841 10.0043494,1.71723582 C10.039195,1.66641931 10.0831332,1.62248118 10.1339497,1.58763557 Z"
              id="Triangle"
              transform="translate(11.474626, 1.999976) scale(-1, 1) translate(-11.474626, -1.999976) "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const cart = ({ style, color }) => (
  <svg
    style={style}
    width="24px"
    height="19px"
    viewBox="0 0 24 19"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g id="Cart" transform="translate(0.000000, -5.000000)" fill={color}>
        <g transform="translate(0.000000, 5.000000)">
          <path
            d="M6.20813639,2.32582527 C6.03110247,2.53833705 5.96218994,2.8151513 6.0200131,3.08490796 L8.20620384,13.2882183 C8.30363191,13.7422564 8.73096883,14.0422039 9.19434622,13.9951533 L21.2302768,12.6714637 C21.6869213,12.6208843 22.0588114,12.2880014 22.1554474,11.8429814 L23.9796493,3.41386993 C24.0366803,3.15077877 23.9725204,2.87866958 23.8038035,2.66772615 C23.6350866,2.45678272 23.3824073,2.33288285 23.1107177,2.32739362 L6.92617332,2 L6.90795506,2 C6.63586937,2 6.38160588,2.11801854 6.20813639,2.32582527"
            id="Fill-1"
          />
          <path
            d="M13,17.5 C13,18.3283333 12.3283333,19 11.5,19 C10.6716667,19 10,18.3283333 10,17.5 C10,16.6716667 10.6716667,16 11.5,16 C12.3283333,16 13,16.6716667 13,17.5"
            id="Fill-4"
          />
          <path
            d="M20,17.5 C20,18.3283333 19.3283333,19 18.5,19 C17.6716667,19 17,18.3283333 17,17.5 C17,16.6716667 17.6716667,16 18.5,16 C19.3283333,16 20,16.6716667 20,17.5"
            id="Fill-6"
          />
          <path
            d="M8.41239019,16 C7.59393427,16 6.87745988,15.4605766 6.70083657,14.6814095 L3.71603287,1.53353312 C3.6231646,1.12431539 3.2360688,0.82670249 2.79646337,0.82670249 L0.433963899,0.82670249 C0.194415827,0.82670249 0,0.641934484 0,0.413351245 C0,0.184768007 0.194415827,0 0.433963899,0 L2.79646337,0 C3.64182504,0 4.38563917,0.571664772 4.56443229,1.35868554 L7.54923599,14.5069753 C7.64557598,14.9327271 8.06218132,15.216286 8.51654152,15.1675106 L22.5170848,13.6434846 C22.7496895,13.6137233 22.9705771,13.7798905 22.9970489,14.0072336 C23.0248226,14.2341635 22.8534069,14.4387723 22.6155947,14.4644001 L8.61505133,15.9888395 C8.54735296,15.9962798 8.47922063,16 8.41239019,16"
            id="Fill-8"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const bag = ({ style, color }) => (
  <svg
    style={style}
    width="18px"
    height="17px"
    viewBox="0 0 18 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="03-–-Seller-Dashboard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g
        id="Dashboard-Product-–-Price-Product"
        transform="translate(-103.000000, -236.000000)"
        fill={color}>
        <g id="Page-1" transform="translate(103.000000, 236.000000)">
          <path
            d="M17.8199623,7.2715773 C17.6697469,7.09865894 17.4499873,7 17.2146498,7 L17.1985156,7 L16.5225463,7.01326061 C16.3650983,7.01644316 16.2299045,7.12305846 16.1970796,7.26998602 L14.5341396,14.7457876 C14.3878186,15.4019226 13.7864007,15.8570268 13.0981916,15.8570268 C13.043669,15.8570268 12.9880337,15.8543747 12.9323984,15.8480096 L4.20098938,14.9234798 C4.0780353,14.9102192 3.97844805,15.0157737 4.0040403,15.1298149 L4.0207309,15.2024831 C4.10362755,15.5727193 4.42631247,15.8506617 4.82132333,15.8925652 L15.2357011,16.995848 C15.6373882,17.0356298 16.0068068,16.7857999 16.0913725,16.4070769 L17.9824174,7.90384319 C18.0330456,7.67947367 17.9729594,7.44873905 17.8199623,7.2715773"
            id="Fill-1"
            fillOpacity="0.6"
          />
          <path
            d="M11.634766,5.12307403 L11.634766,3.57265617 C11.634766,3.44613448 11.6278008,3.32172149 11.6144062,3.19889002 C12.254131,3.6201018 12.6966877,4.30806348 12.7765193,5.10040556 L11.634766,5.12307403 Z M5.3639631,3.57265617 C5.3639631,2.14032523 6.54857906,0.974744173 8.00430116,0.974744173 C8.76243394,0.974744173 9.44502134,1.29210274 9.92669015,1.79713515 C8.07395293,1.90889597 6.59465639,3.39130842 6.52607618,5.2258729 L5.3639631,5.24906854 L5.3639631,3.57265617 Z M10.5214092,2.78927605 C10.6012408,3.03652052 10.6446392,3.29958019 10.6446392,3.57265617 L10.6446392,5.14310663 L7.51673873,5.2058403 C7.59817773,3.8446778 8.74582467,2.76080867 10.1495758,2.76080867 C10.2760206,2.76080867 10.3997864,2.77240649 10.5214092,2.78927605 L10.5214092,2.78927605 Z M13.6616326,14.4102931 L15.4832945,5.95969869 C15.5315149,5.73617704 15.4741861,5.50738365 15.3263101,5.33130764 C15.1816487,5.15839466 14.9700144,5.06086753 14.7433783,5.06086753 C14.7380205,5.06086753 14.7331984,5.06086753 14.7278406,5.0613947 L13.7655745,5.08037296 C13.6493096,3.60534094 12.6211423,2.37808057 11.2340004,1.94948835 C10.6323162,0.794450767 9.41233858,0 8.00430116,0 C6.0026163,0 4.37383633,1.60260805 4.37383633,3.57265617 L4.37383633,5.26910114 L1.2411138,5.33183481 C1.01447764,5.3360522 0.803914965,5.43937825 0.663539849,5.61439992 C0.523164733,5.78889441 0.469586444,6.01399758 0.516735338,6.23224749 L2.03728717,13.2130816 C2.1176546,13.5815761 2.42733711,13.8572879 2.80827874,13.8989346 L12.8381343,14.9959831 C13.223898,15.034994 13.5801936,14.786168 13.6616326,14.4102931 L13.6616326,14.4102931 Z"
            id="Fill-4"
            fillOpacity="0.2"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const payment = ({ style, color }) => (
  <svg
    style={style}
    width="20px"
    height="16px"
    viewBox="0 0 20 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="03-–-Seller-Dashboard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g
        id="Dashboard-Product-–-Price-Product"
        transform="translate(-102.000000, -278.000000)"
        fill={color}>
        <g id="Page-1" transform="translate(102.000000, 278.000000)">
          <g id="Group-2" transform="translate(5.000000, 7.000000)">
            <path
              d="M1.00621154,-0.0001125 C0.744288462,-0.0001125 0.497365385,0.0972 0.308134615,0.27495 C0.109096154,0.4617 5.76923078e-05,0.7131375 5.76923078e-05,0.9820125 L5.76923078e-05,7.905825 C5.76923078e-05,8.1747 0.109096154,8.425575 0.308134615,8.6128875 C0.506596154,8.799075 0.769096154,8.8851375 1.04313462,8.8873875 L14.0285192,8.4351375 C14.5731346,8.4160125 15.0000577,7.984575 15.0000577,7.453575 L15.0000577,1.4342625 C15.0000577,0.9027 14.5731346,0.471825 14.0285192,0.4527 L1.04313462,0.00045 C1.03101923,0.00045 1.01832692,-0.0001125 1.00621154,-0.0001125"
              id="Fill-3"
              fillOpacity="0.2"
            />
            <path
              d="M7.5,6.6938625 L7.5,6.6938625 C6.22557692,6.6938625 5.19230769,5.686425 5.19230769,4.4438625 C5.19230769,3.2013 6.22557692,2.1938625 7.5,2.1938625 C8.77442308,2.1938625 9.80769231,3.2013 9.80769231,4.4438625 C9.80769231,5.686425 8.77442308,6.6938625 7.5,6.6938625"
              id="Fill-6"
              fillOpacity="0.6"
            />
          </g>
          <g id="Group">
            <path
              d="M4,7.83988333 C4,7.41821667 4.08685714,6.99288333 4.29085714,6.63110556 C4.71257143,5.88249444 5.44857143,5.46938333 6.21714286,5.50177222 L15.5285714,5.85743889 C15.7862857,5.86660556 16,5.64660556 16,5.37099444 L16,1.67805 C16,0.727772222 15.2628571,-0.0330611111 14.3748571,0.00116111111 L1.51314286,0.492494444 C0.668571429,0.524272222 0,1.26555 0,2.16938333 L0,8.70888333 C0,9.61210556 0.668571429,10.3533833 1.51314286,10.3857722 L3.52571429,10.4627722 C3.78514286,10.47255 4,10.2501056 4,9.97327222 L4,7.83988333 Z"
              id="Fill-1"
              fillOpacity="0.3"
            />
            <path
              d="M10.2857143,4.8279 C10.2857143,3.47795556 9.26228571,2.38345556 8,2.38345556 C6.73771429,2.38345556 5.71428571,3.47795556 5.71428571,4.8279 C5.71428571,5.07295556 5.75828571,5.30578889 5.82171429,5.52884444 C5.95142857,5.50867778 6.08342857,5.49645556 6.21714286,5.50195556 L10.1428571,5.65167778 C10.2302857,5.39317778 10.2857143,5.11878889 10.2857143,4.8279"
              id="Fill-8"
              fillOpacity="0.6"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const store = ({ style, color }) => (
  <svg
    style={style}
    width="17px"
    height="17px"
    viewBox="0 0 17 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <rect id="path-1" x="0" y="0" width="17" height="17" rx="3" />
      <path
        d="M1,0 L6.96875,0 C7.52103475,3.89074334e-16 7.96875,0.44771525 7.96875,1 L7.96875,8.47368421 L7.96875,8.47368421 C7.96875,9.02596896 7.52103475,9.47368421 6.96875,9.47368421 L1,9.47368421 C0.44771525,9.47368421 6.76353751e-17,9.02596896 0,8.47368421 L0,1 L0,1 C-6.76353751e-17,0.44771525 0.44771525,-3.42636147e-16 1,-4.4408921e-16 L1,0 Z M10.03125,0 L16,0 C16.5522847,3.89074334e-16 17,0.44771525 17,1 L17,8.47368421 C17,9.02596896 16.5522847,9.47368421 16,9.47368421 L10.03125,9.47368421 C9.47896525,9.47368421 9.03125,9.02596896 9.03125,8.47368421 L9.03125,1 L9.03125,1 C9.03125,0.44771525 9.47896525,-3.42636147e-16 10.03125,-4.4408921e-16 L10.03125,0 Z M1,10.5263158 L6.96875,10.5263158 C7.52103475,10.5263158 7.96875,10.974031 7.96875,11.5263158 L7.96875,19 C7.96875,19.5522847 7.52103475,20 6.96875,20 L1,20 L1,20 C0.44771525,20 6.76353751e-17,19.5522847 0,19 L0,11.5263158 C-6.76353751e-17,10.974031 0.44771525,10.5263158 1,10.5263158 L1,10.5263158 Z M10.03125,10.5263158 L16,10.5263158 C16.5522847,10.5263158 17,10.974031 17,11.5263158 L17,19 C17,19.5522847 16.5522847,20 16,20 L10.03125,20 L10.03125,20 C9.47896525,20 9.03125,19.5522847 9.03125,19 L9.03125,11.5263158 C9.03125,10.974031 9.47896525,10.5263158 10.03125,10.5263158 Z"
        id="path-3"
      />
    </defs>
    <g
      id="03-–-Seller-Dashboard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g
        id="Dashboard-Product-–-Price-Product"
        transform="translate(-104.000000, -317.000000)">
        <g id="Group-3" transform="translate(104.000000, 317.000000)">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <use id="Mask" fillOpacity="0.2" fill={color} xlinkHref="#path-1" />
          <g mask="url(#mask-2)" id="Combined-Shape">
            <g transform="translate(5.000000, -1.000000)">
              <g>
                <mask id="mask-4" fill="white">
                  <use xlinkHref="#path-3" />
                </mask>
                <use
                  id="Mask"
                  fillOpacity="0.4"
                  fill="#5A585E"
                  xlinkHref="#path-3"
                />
                <path
                  d="M8.5,16.8421053 L18.0625,16.8421053 L18.0625,20 L8.5,20 L8.5,16.8421053 Z M-1.0625,16.8421053 L8.5,16.8421053 L8.5,20 L-1.0625,20 L-1.0625,16.8421053 Z M8.5,6.84210526 L18.0625,6.84210526 L18.0625,10 L8.5,10 L8.5,6.84210526 Z M-1.0625,6.84210526 L8.5,6.84210526 L8.5,10 L-1.0625,10 L-1.0625,6.84210526 Z"
                  fillOpacity="0.6"
                  fill="#5A585E"
                  mask="url(#mask-4)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const product = ({ style, color }) => (
  <svg
    style={style}
    width="17px"
    height="17px"
    viewBox="0 0 17 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g
      id="03-–-Seller-Dashboard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g
        id="Dashboard-Product-–-Price-Product"
        transform="translate(-104.000000, -357.000000)"
        fill={color}>
        <g id="Page-1" transform="translate(104.000000, 357.000000)">
          <g id="Group-5" fillOpacity="0.2">
            <path
              d="M17,8.73958125 L17,14.3344 C17,15.8042667 15.8042667,17 14.3344,17 L8.73958125,17 L3.1864375,17 C1.4269375,17 0,15.5730625 0,13.8135625 L0,3.1864375 C0,1.4269375 1.4269375,0 3.1864375,0 L13.8135625,0 C15.5735937,0 17,1.4269375 17,3.1864375 L17,8.73958125 Z"
              id="Combined-Shape"
            />
          </g>
          <path
            d="M5.66666667,7.33333333 C5.66666667,9.54278788 7.45769697,11.3333333 9.66666667,11.3333333 C10.1350303,11.3333333 10.5825455,11.2484848 11,11.1010909 L11,14 L3,14 L3,6 L5.89890909,6 C5.75151515,6.41745455 5.66666667,6.8649697 5.66666667,7.33333333 Z M6,5.74639536 C6.56625679,4.14749391 8.08726047,3 9.88040697,3 C12.155421,3 14,4.84407965 14,7.11959303 C14,8.91273953 12.8525061,10.4337432 11.2536046,11 L11.2536046,5.74639536 L6,5.74639536 Z"
            id="Combined-Shape"
            opacity="0.800000012"
          />
        </g>
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/assets/Icons.js